const css = `.FjUAHW__iconWrapper{position:relative}.FjUAHW__iconWrapper svg{display:block}.FjUAHW__iconWrapper .FjUAHW__dot{box-sizing:border-box;border:2px solid var(--base-backgrounds-default);pointer-events:none;border-radius:100%;transition:border-color,background-color,all .15s ease-in-out;display:none;position:absolute}.FjUAHW__iconWrapper .FjUAHW__dot.FjUAHW__enabled{display:inline-block}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"enabled":"FjUAHW__enabled","iconWrapper":"FjUAHW__iconWrapper","dot":"FjUAHW__dot"};
